module.exports = __webpack_public_path__ + "static/media/ic_near_me_24px.4bd27b51.svg";